storageTrie